document.addEventListener("DOMContentLoaded", function () {
    const toggle = document.getElementById("toggle-advanced");
    const table = document.querySelector(".spec-table");

    function update() {
      if (toggle.checked) {
        table.classList.remove("hide-advanced");
      } else {
        table.classList.add("hide-advanced");
      }
    }

    toggle.addEventListener("change", update);
    update();
  });
